import { DriverFilters } from "../model/driver";
import {
  Http,
  Response,
  Headers,
  Request,
  RequestOptions,
} from "@angular/http";
import { throwError as observableThrowError, Observable } from "rxjs";
import { AuthHeaderService } from "../views/authheader.service";
import { environment } from "../../environments/environment";
import { Injectable } from "@angular/core";
import { map, catchError } from "rxjs/operators";

@Injectable()
export class WorkOrderService{
    workorderurl: string;
    constructor(private http: Http, private _headerService: AuthHeaderService){
        this.workorderurl = environment.workorderurl;
    }
    SendForm = (pageFilters: any)=> {
        let options = new RequestOptions({
          headers: this._headerService.getHeader(),
        });
        return this.http.post(this.workorderurl, pageFilters, options).pipe(
          map((response) => response.json()),
          catchError((error: Response) => {
            return observableThrowError(error);
          })
        );
    }

    getWorkOrderData(searchOptions = undefined) {
      let url =this.workorderurl;
      let options = new RequestOptions({
        headers: this._headerService.getHeader(),
      });
      if(searchOptions?.workOrderType){
        url = url + "?workOrderType=" + searchOptions.workOrderType
      }
      return this.http.get(url, options).pipe(
        map((response) => (response.json().data ? [] : response.json())),
        catchError((error: Response) => {
          return observableThrowError(error);
        })
      );
    }

    getItems(){
      let options = new RequestOptions({
        headers: this._headerService.getHeader(),
      });
      return this.http.get(this.workorderurl+"/items", options).pipe(
        map((response) => (response.json().data ? [] : response.json())),
        catchError((error: Response) => {
          return observableThrowError(error);
        })
      );
    }

    getMaintenanceItems(){
      let options = new RequestOptions({
        headers: this._headerService.getHeader(),
      });
      return this.http.get(this.workorderurl+"/maintenanceitems", options).pipe(
        map((response) => (response.json().data ? [] : response.json())),
        catchError((error: Response) => {
          return observableThrowError(error);
        })
      );
    }

    EditWorkOrder = (obj, id)=> {
      delete obj["_id"];
      let options = new RequestOptions({
        headers: this._headerService.getHeader(),
      });
      /* var newobj={};
      newobj["customer"] = obj.customer;
      newobj["vendor"] = obj.vendor;
      newobj["description"] = obj.description; */
      return  this.http.put(this.workorderurl + "/" + id, obj, options).pipe(
        map((response) => {
          return response.json()
        }),
        catchError((error: Response) => {
          return observableThrowError(error);
        })
      );
    }

    getWOVendorBills = (id) => {
      let options = new RequestOptions({ headers: this._headerService.getHeader() });
      return this.http.get(this.workorderurl + '/vendorbill/' + id, options).pipe(map(response => response.json().data ? [] : response.json()), catchError((error: Response) => { return observableThrowError(error); }));
    }
    getWOVendorPaymentByJobNo = (jobNo) => {
      let options = new RequestOptions({ headers: this._headerService.getHeader() });
      return this.http.get(this.workorderurl + '/vendorpayment/' + jobNo, options).pipe(map(response => response.json().data ? [] : response.json()), catchError((error: Response) => { return observableThrowError(error); }));
    }
    getVendorBillsByVendorId = (id) => {
      let options = new RequestOptions({ headers: this._headerService.getHeader() });
      return this.http.get(this.workorderurl + '/vendorbill/vendor/' + id, options).pipe(map(response => response.json().data ? [] : response.json()), catchError((error: Response) => { return observableThrowError(error); }));
    }
    getWOAllVendorBills = () => {
      let options = new RequestOptions({ headers: this._headerService.getHeader() });
      return this.http.get(this.workorderurl + '/vendorbill/', options).pipe(map(response => response.json().data ? [] : response.json()), catchError((error: Response) => { return observableThrowError(error); }));
    }

    getWOCustomerBills = (id) => {
      let options = new RequestOptions({ headers: this._headerService.getHeader() });
      return this.http.get(this.workorderurl + '/customerbill/' + id, options).pipe(map(response => response.json().data ? [] : response.json()), catchError((error: Response) => { return observableThrowError(error); }));
    }
    getCustomerBillsByCustomerId = (id) => {
      let options = new RequestOptions({ headers: this._headerService.getHeader() });
      return this.http.get(this.workorderurl + '/customerbill/customer/' + id, options).pipe(map(response => response.json().data ? [] : response.json()), catchError((error: Response) => { return observableThrowError(error); }));
    }

    createWorkOrderVendorBills = (obj)=>{
      // console.log("createWorkOrdervendorbills ",obj)
      let options = new RequestOptions({
        headers: this._headerService.getHeader(),
      });
        return this.http.post(this.workorderurl+"/vendorbill",obj,options).pipe(
          map((response) => {
            return response.json()
          }),
          catchError((error: Response) => {
            console.log(error);
            return observableThrowError(error);
          })
        );
    }
    createWorkOrderCustomerBills = (obj)=>{
      let options = new RequestOptions({
        headers: this._headerService.getHeader(),
      });
        return this.http.post(this.workorderurl+"/customerbill",obj,options).pipe(
          map((response) => {
            // console.log("createWorkOrderCustomerBills "+response);
            return response.json()
          }),
          catchError((error: Response) => {
            console.log(error);
            return observableThrowError(error);
          })
        );
    }
    getWOSummary= () => {
      let options = new RequestOptions({ headers: this._headerService.getHeader() });
      return this.http.get(this.workorderurl + '/summary', options).pipe(map(response => response.json().data ? [] : response.json()), catchError((error: Response) => { return observableThrowError(error); }));
    }
    getWoVendorBillsByIds(ids: string[]){
      //let params = new HttpParams();
      //console.log("hit");
      let params =  ids.join(',');
      let options = new RequestOptions({headers: this._headerService.getHeader(), params : params});
      return this.http.get(this.workorderurl + '/vendorBillListForIds/' + params, options).pipe(map(response => response.json().data ? [] : response.json()), catchError((error: Response) => { return observableThrowError(error); }));
  }

}
